import { Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const pagePdfStyles = StyleSheet.create({
  page: {
    padding: Spacing.S32,
  },
})
